import React from 'react';
import ResponderMap from 'features/Responder/features/ResponderMap/index';

const ScheduleMapView = ({ showPersonnel = false, ...props }) => (
  <ResponderMap
    editable={false}
    enableTools={false}
    enableContextMenu={false}
    activeSelectionOnly={true}
    focusOnPrimaryTourChange={true}
    focusOnPrimaryZoneChange={true}
    autoSelectZones={false}
    disableLocationSync={true}
    showPersonnel={showPersonnel}
    {...props}
  />
);

export default ScheduleMapView;
